<template>
    <form-field v-clickaway="removeFocus" v-bind="fieldProps">
        <text-input
            :placeholder="$t('forms.common.fields.birth_date.placeholder.month')"
            v-bind="inputProps"
            :isRequired="isRequired"
            :attrs="{ maxlength: 2 }"
            :value="getPart(inputProps.value, 'month')"
            :prefill="getPart(inputProps.prefill, 'month')"
            :numericOnly="true"
            @change="changeDate('month', $event)"
            @focus="gainFocus()"
        ></text-input>

        <text-input
            :placeholder="$t('forms.common.fields.birth_date.placeholder.day')"
            v-bind="inputProps"
            :isRequired="isRequired"
            :attrs="{ maxlength: 2 }"
            :value="getPart(inputProps.value, 'day')"
            :prefill="getPart(inputProps.prefill, 'day')"
            :numericOnly="true"
            @change="changeDate('day', $event)"
            @focus="gainFocus()"
        ></text-input>

        <text-input
            :placeholder="$t('forms.common.fields.birth_date.placeholder.year')"
            v-bind="inputProps"
            :isRequired="isRequired"
            :attrs="{ maxlength: 4 }"
            :value="getPart(inputProps.value, 'year')"
            :prefill="getPart(inputProps.prefill, 'year')"
            :numericOnly="true"
            @change="changeDate('year', $event)"
            @focus="gainFocus()"
        ></text-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'
    import FormPrefillingMixin from 'mixins/FormPrefillingMixin'

    export default {
        mixins: [FormFieldMixin, FormPrefillingMixin],

        props: {
            isSuggested: { type: Boolean, default: false },
        },

        data() {
            return {
                year: null,
                month: null,
                day: null,
                hasFocus: false,
            }
        },

        methods: {
            gainFocus() {
                this.hasFocus = true
            },
            removeFocus() {
                if (this.hasFocus) {
                    this.hasFocus = false
                    this.clear()
                }
            },

            getPart(value, name) {
                return (value || '').split('-')[['year', 'month', 'day'].indexOf(name)]
            },

            clear() {
                if (!this.hasFocus && (!this.year || !this.month || !this.day)) {
                    this.change(null)
                    return true
                }
                return false
            },

            changeDate(part, value) {
                this[part] = value

                if (!this.clear()) {
                    this.change([this.year, this.month, this.day].join('-'))
                }
            },
        },

        watch: {
            'inputProps.value': function (newValue) {
                this.year = this.getPart(newValue, 'year')
                this.month = this.getPart(newValue, 'month')
                this.day = this.getPart(newValue, 'day')
            },
        },
    }
</script>
